import Input from "../../../../../../../../components/Input";

import { PatientVital } from "../../../../../../../../services";
import { VitalFormik } from "../vital-constant";

interface ForceExpiratoryVolumeFieldsProps {
  formik: VitalFormik;
  ind: number;
}

const ForceExpiratoryVolumeFields = ({
  formik,
  ind,
}: ForceExpiratoryVolumeFieldsProps) => {
  const activeVital =
    ind !== -1 ? formik.values?.patientVitals?.[ind] : undefined;

  const isSelected = activeVital?.selected ?? false;

  const getKey = (k: keyof PatientVital) => `patientVitals.${ind}.${k}`;

  const getError = (key: keyof PatientVital) => {
    const touched = (formik.touched.patientVitals as any)?.[ind]?.[key];
    const error = (formik.errors.patientVitals as any)?.[ind]?.[key];
    return touched && error ? String(error) : undefined;
  };

  return (
    <Input
      required={isSelected}
      error={getError("value")}
      textFieldProps={{
        name: getKey("value"),
        placeholder: "10",
        value: activeVital?.value,
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
      }}
    />
  );
};

export default ForceExpiratoryVolumeFields;
